import styles from './my-markdown.module.css';
import Markdown from 'markdown-to-jsx';

export default function MyMarkdown({
	text,
	truncate = false,
}: {
	text: string;
	truncate?: boolean;
}) {
	// Function to extract first paragraph from markdown
	const getFirstParagraph = (content: string) => {
		if (!content) return '';

		// Remove code blocks first as they might contain paragraph-like structures
		const withoutCodeBlocks = content.replace(/```[\s\S]*?```/g, '');

		// Split by double newlines to find paragraphs
		const paragraphs = withoutCodeBlocks.split(/\n\s*\n/);

		// Find the first non-empty paragraph that isn't a header
		for (let paragraph of paragraphs) {
			paragraph = paragraph.trim();
			if (
				paragraph &&
				!paragraph.startsWith('#') &&
				!paragraph.startsWith('>')
			) {
				// If it's a list, just return the first item
				if (
					paragraph.startsWith('-') ||
					paragraph.startsWith('*') ||
					/^\d+\./.test(paragraph)
				) {
					const listItems = paragraph.split(/\n/);
					if (listItems.length > 0) {
						return listItems[0];
					}
				}
				return paragraph;
			}
		}

		// Fallback: return first 200 characters
		return content.substring(0, 200) + (content.length > 200 ? '...' : '');
	};

	const contentToRender = truncate ? getFirstParagraph(text) : text;

	return (
		<div className={styles['md-container']}>
			<Markdown>{contentToRender}</Markdown>
			{truncate && text.length > contentToRender.length && (
				<span className={styles.ellipsis}>...</span>
			)}
		</div>
	);
}
